import { KeyboardPlugin } from '@capacitor/keyboard/dist/esm/definitions';

type KeyboardModuleCompat = typeof import('@capacitor/keyboard');

export * from '@capacitor/keyboard/dist/esm/definitions';
// We are intentionally using a mutable export so that we can mimic the original import
// syntax for Capacitor plugins, while still dynamically loading the correct capacitor version.
// Don't remove or try to fix the skipcq, as this syntax is mandatory for the compatibility bridge.
// skipcq: JS-E1009
export let Keyboard: KeyboardPlugin;

const load = (module: KeyboardModuleCompat) => {
  Keyboard = module.Keyboard;
};

export default load;
